import type { FC, ReactNode } from 'react'

interface MarathonMarkProps {
    className?: string
    color?: string
}

/* A small route-line mark: a winding path with a start and finish node,
   echoing the running-route motif used throughout the product. */
export const MarathonMark: FC<MarathonMarkProps> = ({
    className,
    color = '#E94E1B'
}): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            className={className}
            aria-hidden='true'
        >
            <path
                d='M4 19 C 6 14, 9 13, 11 11 C 13 9, 12 6, 15 5 C 17.5 4.2, 19 5, 20 3'
                stroke={color}
                strokeWidth='2.2'
                strokeLinecap='round'
                fill='none'
            />
            <circle cx='4' cy='19' r='2.2' fill={color} />
            <circle cx='20' cy='3' r='2.2' fill={color} />
        </svg>
    )
}
